import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

type UseTooltipParams = Readonly<{
  isDisabled: boolean;
  title: ReactNode;
}>;

function useTooltip({ isDisabled, title }: UseTooltipParams) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isDisabled) setIsOpen(false);
  }, [isDisabled]);

  useEffect(() => {
    if (!isOpen) return;
    function handleEscape(e: KeyboardEvent) {
      if (e.key === 'Escape') setIsOpen(false);
    }
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen]);

  function handleOpen() {
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }

  const hasContent = !isDisabled && Boolean(title);

  return { handleClose, handleOpen, hasContent, isOpen };
}

export default useTooltip;
